import { defaultConfig, defineSlotRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

export const searchEngineInstantReservationCheckboxSlotRecipe = defineSlotRecipe(
    merge(defaultConfig?.theme?.slotRecipes?.checkbox, {
        base: {
            root: {
                display: 'flex',
                gap: 2,
            },
        },
        variants: {
            variant: {
                withBg: {
                    root: {
                        bg: 'orange.50',
                        borderBottomRadius: 'xl',
                        px: {
                            base: 4,
                            lg: 6,
                        },
                        py: {
                            base: 3,
                            md: 4,
                        },
                        _before: {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            height: '100%',
                            boxShadow: 'searchBar',
                            borderBottomRadius: 'md',
                            zIndex: -1,
                        },
                    },
                },
            },
        },
    }),
);
